import * as Sentry from '@sentry/react';
import { isProd } from '../api/constants';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: isProd ? 'production' : 'development'
});
